import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const WithQueryTitleWrapper = styled(Box)`
  margin-right: 4px;
  height: 20px;
`
